import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a3c1ef62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-container" }
const _hoisted_2 = { class: "main-section" }
const _hoisted_3 = { class: "h-100 d-flex flex-column justify-content-center" }
const _hoisted_4 = { class: "dark-strip" }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 d-flex align-content-center justify-content-end" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-100 logo",
    src: "https://assets.logicworld.net/img/logo_white.svg",
    alt: "Logic World logo"
  })
], -1))
const _hoisted_8 = { class: "col-lg-6 d-flex flex-column justify-content-lg-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "promo text-center" }, [
  /*#__PURE__*/_createTextVNode("The ultimate digital logic simulator."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Now available for Windows, Mac and Linux.")
], -1))
const _hoisted_10 = {
  class: "btn btn-secondary mt-2",
  href: "https://store.steampowered.com/app/1054340/Logic_World/",
  target: "_blank"
}
const _hoisted_11 = { class: "d-flex buttons" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["TitleTag"], { title: "" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["background", {moving: $setup.moving}]),
          style: _normalizeStyle({'--transition-dur': $setup.transitionDurationStr})
        }, [
          _createVNode($setup["ResponsiveImg"], {
            class: "image current",
            base: $setup.images[$setup.currentImage],
            cover: "cover",
            alt: "Current background image"
          }, null, 8, ["base"]),
          ($setup.loadImage !== null)
            ? (_openBlock(), _createBlock($setup["ResponsiveImg"], {
                key: 0,
                class: "image next",
                base: $setup.images[$setup.loadImage],
                onLoad: $setup.imageLoaded,
                cover: "cover",
                "aria-hidden": "true"
              }, null, 8, ["base"]))
            : _createCommentVNode("", true)
        ], 6),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("a", _hoisted_10, [
                    _createVNode(_component_icon, {
                      class: "me-2",
                      icon: ['fab', 'steam']
                    }),
                    _createTextVNode("Buy now on Steam")
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_router_link, {
                      class: "btn btn-success text-dark-on-light flex-grow-1",
                      to: "/newsletter"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Subscribe to our newsletter")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_router_link, {
                      class: "btn btn-primary text-dark-on-light flex-grow-1",
                      to: "/view/frm-devupdts"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Read our development blog")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}